/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";
// Formik and Yup
import { useFormik } from "formik";
import TextError from "utils/TextError";
import * as Yup from "yup";

// Dashboard example components

import DataTable from "examples/Tables/DataTable";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDTypography from "components/MDTypography";

// @mui material components
import Alert from "@mui/material/Alert";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";

// @mui material icons
import CloseIcon from "@mui/icons-material/Close";

// React-Select component and styling
import Select from "react-select";
// Functions from store
import {
  createDynamicColumn,
  getDynamicColumn,
  getShipment,
  getSkuBySkuType,
  getSubModulesByRoleId,
  releaseShipment,
  uploadCsvForSalesOrder,
} from "../../../store";

// Config
import Config from "../../../config/index";

// Cookies
import Cookies from "universal-cookie";

import DownloadButton from "components/standardized-components/DownloadButton";
import ReleaseButton from "components/standardized-components/ReleaseButton";
import UploadButton from "components/standardized-components/UploadButton";
import { CSVLink } from "react-csv";
import { toast, ToastContainer } from "react-toastify";

const cookies = new Cookies();

const styleForPicklistViewModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  height: "fit-content",
  maxHeight: { xs: 340, sm: 340, md: 440, lg: 600, xl: 600 },
  overflow: "scroll",
  width: { xs: 350, lg: 1000 },
  color: "black",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 300, lg: 750 },
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 2,
};

const styleForRelease = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 2,
};

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  boxShadow: 24,
  p: 2,
  pt: 3,
};
const styleForColumnReorder = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const SalesOrderAndShipment = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getShipment,
  getShipmentReducer,
  releaseShipment,
  getSkuBySkuType,
  getSkuBySkuTypeReducer,
  uploadCsvForSalesOrder,
    getDynamicColumn,
  createDynamicColumn,
  getDynamicColumnReducer
}) => {
  const desLength = Config.descriptionLength;

  
let dynamicColumnDetails = cookies.get("dynamic-column-data");
  let loginDetails = cookies.get("loginDetailsForWMS");
  
  let userId = loginDetails.data.userId;

  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : []
    );
  }, [getSubModulesByRoleIdReducer]);
  
  const subModuleId = "f57c47e3-6c3f-4590-9c6f-a649eafe60f5";

  let picklistTrackingModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "f57c47e3-6c3f-4590-9c6f-a649eafe60f5"
  );

  let viewShipment = picklistTrackingModule
    ? picklistTrackingModule.actionId.includes(
        "9d28999c-9364-4781-b5ec-4724add31305"
      )
    : null;
  let releaseAccess = picklistTrackingModule
    ? picklistTrackingModule.actionId.includes("")
    : null;
  let uploadPoListing = picklistTrackingModule
    ? picklistTrackingModule.actionId.includes("")
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});

  const [uncheck, setUncheck] = useState(false);

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    viewShipment && getShipment(pageNo, rowsPerPage, searchObject, jwtToken);
  }, [viewShipment, pageNo, rowsPerPage, searchObject]);

  const statusOptions = [
    {
      label: "All Status",
      value: "",
    },
    {
      label: "Created",
      value: 0,
    },
    {
      label: "Released",
      value: 1,
    },
    {
      label: "Open(Picking)",
      value: 2,
    },
    {
      label: "Open(Picked)",
      value: 3,
    },
    {
      label: "Open(Delivering)",
      value: 4,
    },
    {
      label: "Delivered",
      value: 5,
    },
  ];

  const [state, setState] = useState({
    columns: [
      { Header: "So Number", accessor: "salesOrderNumber" },
      { Header: "so Line Number", accessor: "salesOrderLineNumber" },
      { Header: "so qty", accessor: "salesOrderQty" },
      { Header: "shipment", accessor: "tripNo" },
      { Header: "fg model code", accessor: "fgModelCode" },
      { Header: "fg item code", accessor: "itemCode" },
      { Header: "Customer code", accessor: "customerCode", align: "left" },
      { Header: "Customer Name", accessor: "customerName", align: "left" },

      {
        Header: "Actions",
        accessor: "action",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });
  const { columns, rows } = state;

  useEffect(() => {
    let tempPicklist = [];

    let data = getShipmentReducer.sku.data ? getShipmentReducer.sku.data : [];

    setPaginationObj(getShipmentReducer?.sku?.pagination);

    setLoading(getShipmentReducer.loading);

    data.map((picklist) => {
      const picklistObject = {
        privateKey: picklist.salesOrderNumber,
        salesOrderNumber: picklist.salesOrderNumber,
        salesOrderLineNumber: picklist.salesOrderLineNumber,
        tripNo: picklist.tripNo,
        customerCode: picklist.customerCode,
        customerName: picklist.customerName,
        fgModelCode: picklist.fgModelCode,
        qty: picklist.qty,
        uom: picklist.uom,
        cd: picklist.cd,
        ud: picklist.ud,
        itemCode: picklist.itemCode,
        salesOrderQty: picklist.salesOrderQty,
        status: (
          <button
            className={
              (picklist.status === 0 && `status-created`) ||
              (picklist.status === 1 && `status-warning`) ||
              (picklist.status === 2 && `status-info`) ||
              (picklist.status === 3 && `status-info`) ||
              (picklist.status === 4 && `status-info`) ||
              (picklist.status === 5 && `status-success`)
            }
            style={{ width: "5.5rem" }}
          >
            {(picklist.status === 0 && `Created`) ||
              (picklist.status === 1 && `Released`) ||
              (picklist.status === 2 && `Open(Picking)`) ||
              (picklist.status === 3 && `Open(Picked)`) ||
              (picklist.status === 4 && `Open(Delivering)`) ||
              (picklist.status === 5 && `Delivered`)}
          </button>
        ),

        action: (
          <span style={{ display: "flex" }}>
            {!releaseAccess && (
              <ReleaseButton
                disabled={picklist.tripStatus !== 0}
                tooltip="Release"
                style={{
                  marginLeft: "0.3rem",
                }}
                type="button"
                variant="gradient"
                color="success"
                iconOnly
                onClick={() => {
                  handleOpenAllocateUserModal(picklist);
                }}
              >
                {" "}
                <Icon>forward</Icon>
              </ReleaseButton>
            )}
          </span>
        ),
      };
      tempPicklist.push(picklistObject);
    });
    setState({ ...state, rows: tempPicklist });
  }, [getShipmentReducer]);

  const [errorMsg, setErrorMsg] = useState("");

  const [isErrorForAllocate, setIsErrorForAllocate] = useState(false);
  const [isSuccessForAllocate, setIsSuccessForAllocate] = useState(false);

  const [releaseButtonName, setReleaseButtonName] = useState("Submit");

  const [selectedRejectData, setSelectedRejectData] = useState([]);
  const RejectForData = (data) => {
    setSelectedRejectData(data);
  };

  const [disableButton, setDisableButton] = useState(false);

  useEffect(() => {
    let value = selectedRejectData.some(
      (data) => data.status2 === "Delivered" || data.status2 === "Open"
    );
    setDisableButton(value);
  }, [selectedRejectData]);

  const [openAcceptQuarantineModal, setOpenAcceptQuarantineModal] =
    useState(false);

  const [denyButtonName, setDenyButtonName] = useState("Deny");

  const handleOpenAcceptQuarantineModal = (Quarantine = {}) => {
    setOpenAcceptQuarantineModal(true);
    setIsErrorForAccept(false);
    setIsSuccessForAccept(false);
  };
  const handleCloseAcceptQuarantineModal = () => {
    setOpenAcceptQuarantineModal(false);
    formikForAccept.setErrors({});
  };

  const [selectedData, setSelectedData] = useState("");

  const [allocateUserModal, setAllocateUserModal] = useState(false);
  const [suidData, setSuidData] = useState(false);

  const [isErrorForAccept, setIsErrorForAccept] = useState(false);
  const [isErrorMsgForAccept, setIsErrorMsgForAccept] = useState("");
  const [isSuccessForAccept, setIsSuccessForAccept] = useState(false);

  const [selectedSkuType, setSelectedSkuType] = useState("");

  const handleSkuTypeChange = (selectedSkuType) => {
    setSelectedSkuType(selectedSkuType);
    setSelectedUser("");
  };
  const skuTypeOptions = [
    {
      label: "Primary",
      value: 1,
    },
    {
      label: "Secondary",
      value: 2,
    },
  ];

  const [selectedUser, setSelectedUser] = useState("");

  const handleUserChange = (selectedUser) => {
    setSelectedUser(selectedUser);
  };
  const [userOptions, setUserOptions] = useState([]);

  useEffect(() => {
    let tempDocumentTypeOptions = [];
    let data = getSkuBySkuTypeReducer.sku.data
      ? getSkuBySkuTypeReducer.sku.data
      : [];

    data.map((document) => {
      tempDocumentTypeOptions.push({
        label: document.skuCode,
        value: document.skuId,
      });
    });
    setUserOptions(tempDocumentTypeOptions);
  }, [getSkuBySkuTypeReducer]);
  useEffect(() => {
    if (isErrorForAccept) {
      setTimeout(() => {
        setIsErrorForAccept(false);
      }, 3000);
    }
  }, [isErrorForAccept]);

  useEffect(() => {
    if (isSuccessForAccept) {
      setTimeout(() => {
        setIsSuccessForAccept(false);
      }, 3000);
    }
  }, [isSuccessForAccept]);

  const initialValueForAccept = {
    user: "",
  };

  const validationSchemaForAccept = Yup.object({
    // documentNumber: Yup.string().required("Enter document number!"),
  });

  const onSubmitForAccept = async (values) => {
    setReleaseButtonName("Please wait...");
    let tempArray = [];
    selectedRejectData.map((data) => {
      const quantity = parseFloat(data.qty);
      const tempPayload = {
        picklistId: data.picklistId,
      };
      tempArray.push(tempPayload);
    });

    let payload = {
      salesOrderId: selectedData?.salesOrderId,
      tripNo: selectedData?.tripNo,
      salesOrderQty: selectedData?.salesOrderQty,
      itemId: selectedData?.itemId,
      skuId: selectedUser?.value,
      skuTypeId: selectedSkuType?.value,
      mvtId: 14,
      // picklist:
      //   selectedRejectData.length !== 0
      //     ? tempArray
      //     : [{ picklistId: pickListId }],
    };

    let res = await releaseShipment(payload, jwtToken);
    if (res.status) {
      // setUncheck(!uncheck);
      setIsSuccessForAccept(true);
      getShipment(pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        handleCloseAllocateUserModal();
        setReleaseButtonName("Submit");
      }, 2000);
    }
    if (!res.status) {
      console.log(res);
      setIsErrorForAccept(true);
      setIsErrorMsgForAccept(res?.message?.data?.msg);
      setReleaseButtonName("Submit");
    }
  };

  const formikForAccept = useFormik({
    initialValues: initialValueForAccept,
    onSubmit: onSubmitForAccept,
    validationSchema: validationSchemaForAccept,
    enableReinitialize: true,
  });

  const handleOpenAllocateUserModal = (picklist) => {
    setAllocateUserModal(true);
    formikForAccept.setValues(initialValueForAccept);
    formikForAccept.setTouched({});
    formikForAccept.setErrors({});
    setSelectedData(picklist);
    setSelectedSkuType("");
    setSelectedUser("");
  };
  const handleCloseAllocateUserModal = () => {
    setAllocateUserModal(false);
    setUserOptions([]);
  };

  const [selectedItemCode, setSelectedItemCode] = useState("");

  const handleItemCodeChange = (selectedItemCode) => {
    setSelectedItemCode(selectedItemCode);
  };

  const [itemCodeOptions, setItemCodeOptions] = useState([]);

  const [isSuccessAllocateItem, setIsSuccessAllocateItem] = useState(false);
  const [isErrorAllocateItem, setIsErrorAllocateItem] = useState(false);

  const [createErrorMsg, setCreateErrorMsg] = useState("");
  useEffect(() => {
    if (isSuccessAllocateItem) {
      setTimeout(() => {
        setIsSuccessAllocateItem(false);
      }, 3000);
    }
  }, [isSuccessAllocateItem]);

  useEffect(() => {
    if (isErrorAllocateItem) {
      setTimeout(() => {
        setIsErrorAllocateItem(false);
      }, 3000);
    }
  }, [isErrorAllocateItem]);

  const DataUploadSuccessNotification = () =>
    toast.success("Data Uploaded Successfully", {
      position: "top-center",
      autoClose: 2000,
    });

  const DataUploadFailureNotification = (data) =>
    toast.error(data, {
      position: "top-center",
      autoClose: 2000,
    });

  const [uploadCsvFilter, setUploadCsvFilter] = useState(false);

  const uploadCsvFilterHandler = () => {
    setUploadCsvFilter(!uploadCsvFilter);
  };

  const [uploadCsvData, setUploadCsvData] = useState({});

  const uploadCsvHandler = async () => {
    let data = new FormData();

    data.append("file", uploadCsvData);

    let res = await uploadCsvForSalesOrder(data, jwtToken);

    if (res.status) {
      getShipment(pageNo, rowsPerPage, searchObject, jwtToken);
      setUploadCsvFilter(false);
      DataUploadSuccessNotification();
    }
    if (!res.status) {
      DataUploadFailureNotification(res?.data?.data?.msg);
    }
  };

  const headers = [
    {
      label: "fgCode",
      key: "fgCode",
    },
    {
      label: "quantity",
      key: "quantity",
    },
    {
      label: "salesOrderNumber",
      key: "salesOrderNumber",
    },
    {
      label: "salesOrderLineNumber",
      key: "salesOrderLineNumber",
    },
    {
      label: "tripNumber",
      key: "tripNumber",
    },
    {
      label: "customerCode",
      key: "customerCode",
    },
    {
      label: "customerName",
      key: "customerName",
    },
  ];

  const csvLink2 = {
    filename: "Sales Orders.csv",
    headers: headers,
    data: [],
  };

  
        
          const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
          useEffect(() => {
            getDynamicColumn(userId, subModuleId, jwtToken);
          }, [userId, subModuleId]);
        
          const [dynamicColumnData, setDynamicColumnData] = useState("");
        
          let hiddenColumsDetails = cookies.get("hidden-column-data");
          useEffect(() => {
            let data = getDynamicColumnReducer.dynamicColumn.data
              ? getDynamicColumnReducer.dynamicColumn.data
              : [];
        
            setDynamicColumnData(data);
            cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
              path: "/",
            });
        
            setTimeout(() => {
              setLoadingForDynamicColumn(true);
            }, 1000);
          }, [getDynamicColumnReducer, loading]);
        
          const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
            useState(false);
        
          const handleOpenCreateColumnReorderModal = () => {
            setOpenCreateColumnReorderModal(true);
          };
        
          const handleCloseCreateColumnReorderModal = () => {
            setOpenCreateColumnReorderModal(false);
          };
        
          const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
          const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);
        
          useEffect(() => {
            if (isErrorColumnReorder) {
              setTimeout(() => {
                setIsErrorColumnReorder(false);
              }, 3000);
            }
          }, [isErrorColumnReorder]);
        
          useEffect(() => {
            if (isSuccessColumnReorder) {
              setTimeout(() => {
                setIsSuccessColumnReorder(false);
              }, 3000);
            }
          }, [isSuccessColumnReorder]);
        
          const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
            useState(false);
        
          const handleDynamicColumn = async () => {
            let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
            if (res.status) {
              setIsSuccessColumnReorder(true);
              getDynamicColumn(userId, subModuleId, jwtToken);
        getShipment( pageNo, rowsPerPage, searchObject, jwtToken);
              setTimeout(() => {
                handleCloseCreateColumnReorderModal();
                // window.location.reload();
              }, 2250);
            }
            if (!res.status) {
              setIsErrorColumnReorder(true);
              setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
            }
          };
        
  
  
  return (
    <>
      <MDBox pt={0} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <MDBox color="text" px={2} ml={-2} mb={1}>
              {!uploadPoListing ? (
                <CSVLink {...csvLink2}>
                  <DownloadButton
                    tooltip="Download Template"
                    style={{ marginRight: "1rem" }}
                    type="button"
                    variant="outlined"
                    color="error"
                    iconOnly
                  >
                    <Icon>download</Icon>
                  </DownloadButton>
                </CSVLink>
              ) : (
                ""
              )}
              {!uploadPoListing && (
                <UploadButton
                  tooltip="Upload CSV"
                  style={{ marginRight: "1rem" }}
                  type="button"
                  variant="outlined"
                  color="info"
                  iconOnly
                  onClick={uploadCsvFilterHandler}
                >
                  <Icon>upload</Icon>
                </UploadButton>
              )}
            </MDBox>

            {uploadCsvFilter && (
              <div>
                <div>
                  {/* <input
                                    className="choose_file"
                                    style={{
                                      marginTop: "1.5rem",
                                      marginLeft: "1.5rem",
                                      // marginBottom: "-9rem",
                                    }}
                                    type="file"
                                    accept=".csv"
                                    onChange={(e) => {
                                      setUploadCsvData(e.target.files[0]);
                                    }}
                                  /> */}
                  {/* {downloadPoListing ? (
                                    <CSVLink {...csvLink}>
                                      <DownloadDataButton
                                        tooltip="Download Grn List"
                                        style={{ marginRight: "1rem" }}
                                        type="button"
                                        variant="outlined"
                                        color="success"
                                        iconOnly
                                      >
                                        <Icon>download</Icon>
                                      </DownloadDataButton>
                                    </CSVLink>
                                  ) : (
                                    ""
                                  )} */}
                </div>
              </div>
            )}
            {uploadCsvFilter && (
              <div>
                <div>
                  <input
                    className="choose_file"
                    style={{
                      marginTop: "1.5rem",
                      marginLeft: "1.5rem",
                      // marginBottom: "-9rem",
                    }}
                    type="file"
                    accept=".csv"
                    onChange={(e) => {
                      setUploadCsvData(e.target.files[0]);
                    }}
                  />

                  <MDButton
                    disabled={
                      !uploadCsvData?.name || uploadCsvData?.type !== "text/csv"
                    }
                    variant="contained"
                    color="info"
                    style={{
                      marginLeft: { xs: "1.5rem", lg: "1" },
                      marginTop: "0rem",
                    }}
                    type="button"
                    onClick={uploadCsvHandler}
                  >
                    UPLOAD
                  </MDButton>
                </div>
                <div>
                  <span
                    style={{
                      color: "red",
                      fontSize: "14px",
                      marginLeft: "30px",
                      fontStyle: "italic",
                    }}
                  >
                    <strong>*</strong> Please upload
                    <strong>".csv"</strong> file only
                  </span>
                </div>
              </div>
            )}


            <MDBox>

              <DataTable
                 table={{ columns, rows }}
               isSorted
               tableSearch
               showTotalEntries
               noEndBorder
               loading={loading}
             
               entriesPerPage={{
                 defaultValue: 5,
                 entries: [5, 10, 15, 20, 25, 30],
               }}                                        
               serverSidePagination
               paginationObj={paginationObj}
               pageNoValue={pageNo}
               rowsPerPageValue={rowsPerPage}
               pageNoProp={importPageNo}
               rowsPerPageProp={importRowsPerPage}
               searchProp={importSearch}        
               visibleColumns2={dynamicColumnData?.visibleFields}
               dynamicColumnData={dynamicColumnData}
             
               /* Table options */
               options={{ draggable: false }}
             
               /* Column reorder */
               handleOpenCreateColumnReorderModal={
                 handleOpenCreateColumnReorderModal
               }
             
               /* Meta */
               subModuleId={subModuleId}
               userId={userId}
                    selectionButtonComponent={
                  <>
                    <>
                      {releaseAccess && (
                        <span style={{ display: "flex", alignItems: "center" }}>
                          <span>
                            <Tooltip title="Confirm">
                              <MDButton
                                color="success"
                                type="button"
                                style={{
                                  marginTop: "0rem",

                                  marginLeft: "1rem",
                                }}
                                onClick={(evt, data) =>
                                  handleOpenAllocateUserModal(evt, data)
                                }
                              >
                                Release
                              </MDButton>
                            </Tooltip>
                          </span>
                        </span>
                      )}
                    </>
                  </>
                }
              />
            </MDBox>
          </Grid>

             <Modal
                                                      open={openCreateColumnReorderModal}
                                                      onClose={handleCloseCreateColumnReorderModal}
                                                      aria-labelledby="modal-modal-title"
                                                      aria-describedby="modal-modal-description"
                                                      style={{ backdropFilter: "blur(5px)" }}
                                                    >
                                                      <MDCard sx={styleForColumnReorder}>
                                                        <MDTypography>Are you sure you want to submit?</MDTypography>
                                                        <MDBox mt={2}>
                                                          <MDButton
                                                            style={{ width: "10rem", marginRight: "0.5rem" }}
                                                            color="info"
                                                            variant="outlined"
                                                            onClick={handleCloseCreateColumnReorderModal}
                                                          >
                                                            Cancel
                                                          </MDButton>
                                                          <MDButton
                                                            style={{ width: "10rem", marginLeft: "0.5rem" }}
                                                            color="success"
                                                            onClick={handleDynamicColumn}
                                                            // disabled={denyButtonName === "Please wait..."}
                                                          >
                                                            Submit
                                                          </MDButton>
                                                        </MDBox>
                                                        <MDBox mt={2}>
                                                          <Collapse in={isSuccessColumnReorder}>
                                                            <Alert
                                                              severity="success"
                                                              action={
                                                                <IconButton
                                                                  aria-label="close"
                                                                  color="inherit"
                                                                  size="small"
                                                                  onClick={() => {
                                                                    setIsSuccessColumnReorder(false);
                                                                  }}
                                                                >
                                                                  <CloseIcon fontSize="inherit" />
                                                                </IconButton>
                                                              }
                                                            >
                                                              Data updated successfully!
                                                            </Alert>
                                                          </Collapse>
                                                          <Collapse in={isErrorColumnReorder}>
                                                            <Alert
                                                              severity="error"
                                                              action={
                                                                <IconButton
                                                                  aria-label="close"
                                                                  color="inherit"
                                                                  size="small"
                                                                  onClick={() => {
                                                                    setIsErrorColumnReorder(false);
                                                                  }}
                                                                >
                                                                  <CloseIcon fontSize="inherit" />
                                                                </IconButton>
                                                              }
                                                            >
                                                              {isErrorMsgForColumnReorder}
                                                            </Alert>
                                                          </Collapse>
                                                        </MDBox>
                                                      </MDCard>
                                                    </Modal>
        </Grid>
        <Modal
          open={allocateUserModal}
          onClose={handleCloseAllocateUserModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <MDCard sx={styleForRelease}>
            <MDBox ml={3} mt={-1} display="flex" alignItems="center">
              <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                Release
              </MDTypography>
              <MDBox>
                <Tooltip title="Close">
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    onClick={handleCloseAllocateUserModal}
                    style={{
                      background: "whitesmoke",
                      color: "black",
                      borderRadius: 5,
                      marginLeft: "-55px",
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              </MDBox>
            </MDBox>
            <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

            <MDBox pt={0} pb={3} px={3}>
              <MDBox
                component="form"
                role="form"
                onSubmit={formikForAccept.handleSubmit}
              >
                <MDBox mb={1}>
                  <MDTypography variant="h6" style={{ fontWeight: "500" }}>
                    {" "}
                    SKU Type
                  </MDTypography>

                  <Select
                    isClearable
                    className="select-css"
                    maxMenuHeight={90}
                    placeholder="Choose one..."
                    name="skuType"
                    onBlur={() => {
                      formikForAccept.handleBlur({
                        target: { name: "skuType" },
                      });
                    }}
                    value={selectedSkuType}
                    options={skuTypeOptions}
                    onChange={(selectedOption) => {
                      handleSkuTypeChange(selectedOption);
                      getSkuBySkuType(selectedOption?.value, jwtToken);
                      formikForAccept.setFieldValue("skuType", selectedOption);
                    }}
                  />
                  {formikForAccept.touched.skuType &&
                    formikForAccept.errors.skuType && (
                      <TextError msg={formikForAccept.errors.skuType} />
                    )}
                </MDBox>
                <MDBox mb={1}>
                  <MDTypography variant="h6" style={{ fontWeight: "500" }}>
                    {" "}
                    SKU
                  </MDTypography>

                  <Select
                    isClearable
                    className="select-css"
                    maxMenuHeight={90}
                    placeholder="Choose one..."
                    name="user"
                    onBlur={() => {
                      formikForAccept.handleBlur({
                        target: { name: "user" },
                      });
                    }}
                    value={selectedUser}
                    options={userOptions}
                    onChange={(selectedOption) => {
                      handleUserChange(selectedOption);
                      formikForAccept.setFieldValue("user", selectedOption);
                    }}
                  />
                  {formikForAccept.touched.user &&
                    formikForAccept.errors.user && (
                      <TextError msg={formikForAccept.errors.user} />
                    )}
                </MDBox>
                {/* <MDBox mb={1} mt={1} display="flex" alignItems="center">
                  <input
                    type="checkbox"
                    name="masterCarton"
                    checked={formikForAccept.values.masterCarton || false}
                    onChange={(e) =>
                      formikForAccept.setFieldValue(
                        "masterCarton",
                        e.target.checked
                      )
                    }
                    onBlur={() =>
                      formikForAccept.handleBlur({
                        target: { name: "masterCarton" },
                      })
                    }
                    style={{ width: 18, height: 18, marginRight: 10 }}
                  />
                  <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                    Master Carton
                  </MDTypography>
                </MDBox> */}

                <MDBox mt={2}>
                  <Collapse in={isSuccessForAccept}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsSuccessForAccept(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Released successfully!
                    </Alert>
                  </Collapse>
                  <Collapse in={isErrorForAccept}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorForAccept(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {isErrorMsgForAccept}
                    </Alert>
                  </Collapse>
                </MDBox>
                <MDBox mt={3}>
                  <MDButton
                    color="success"
                    fullWidth
                    type="submit"
                    disabled={
                      !selectedUser ||
                      !selectedSkuType ||
                      releaseButtonName === "Please wait..."
                    }
                  >
                    {releaseButtonName}
                  </MDButton>
                </MDBox>
              </MDBox>
            </MDBox>
          </MDCard>
        </Modal>
        {/* <Modal
          open={allocateUserModal}
          onClose={handleCloseAllocateUserModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <MDCard sx={styleForRelease}>
            <MDBox ml={3} mt={-1} display="flex" alignItems="center">
              <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                Print
              </MDTypography>
              <MDBox>
                <Tooltip title="Close">
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    onClick={handleCloseAllocateUserModal}
                    style={{
                      background: "whitesmoke",
                      color: "black",
                      borderRadius: 5,
                      marginLeft: "-55px",
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              </MDBox>
            </MDBox>
            <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

            <MDBox pt={1} pb={3} px={3}>
              <MDBox
                component="form"
                role="form"
                onSubmit={formikForAccept.handleSubmit}
              >
                <MDBox mb={1}>
                  <MDTypography variant="h6" style={{ fontWeight: "500" }}>
                    {" "}
                    User (Optional)
                  </MDTypography>

                  <Select
                    isClearable
                    className="select-css"
                    maxMenuHeight={130}
                    placeholder="Choose one..."
                    name="user"
                    onBlur={() => {
                      formikForAccept.handleBlur({
                        target: { name: "user" },
                      });
                    }}
                    value={selectedUser}
                    options={userOptions}
                    onChange={(selectedOption) => {
                      handleUserChange(selectedOption);
                      formikForAccept.setFieldValue("user", selectedOption);
                    }}
                  />
                  {formikForAccept.touched.user &&
                    formikForAccept.errors.user && (
                      <TextError msg={formikForAccept.errors.user} />
                    )}
                </MDBox>

                <MDBox>
                  <Collapse in={isErrorForAllocate}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorForAllocate(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {errorMsg}
                    </Alert>
                  </Collapse>
                  <Collapse in={isSuccessForAllocate}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorForAllocate(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Picklist released Successfully
                    </Alert>
                  </Collapse>
                </MDBox>

                <MDBox mt={3}>
                  <MDButton
                    color="success"
                    fullWidth
                    type="submit"
                    disabled={
                      !formikForAccept.isValid ||
                      releaseButtonName === "Please wait..."
                    }
                  >
                    {releaseButtonName}
                  </MDButton>
                </MDBox>
              </MDBox>
            </MDBox>
          </MDCard>
        </Modal> */}
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    getShipmentReducer: state.getShipmentReducer,
    getSkuBySkuTypeReducer: state.getSkuBySkuTypeReducer,
    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getShipment: (pageNo, rowsPerPage, searchObject, jwtToken) =>
      dispatch(getShipment(pageNo, rowsPerPage, searchObject, jwtToken)),
    getSkuBySkuType: (itemId, jwtToken) =>
      dispatch(getSkuBySkuType(itemId, jwtToken)),
    releaseShipment: (payload, jwtToken) =>
      dispatch(releaseShipment(payload, jwtToken)),
    uploadCsvForSalesOrder: (payload, jwtToken) =>
      dispatch(uploadCsvForSalesOrder(payload, jwtToken)),

         getDynamicColumn: (userId, subModuleId, jwtToken) =>
                  dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
                createDynamicColumn: (payload, jwtToken) =>
                  dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(SalesOrderAndShipment);
